import { defineStore } from 'pinia';
import {applyPatch} from 'rfc6902'

export const useLiveHomeFixturesStore = defineStore('liveHomeFixtures', {
	state: () => ({
		fixtures: {},
	}),
	getters: {
		liveHomeFixtures(state) {
			return state.fixtures;
		}
	},
	actions: {
		setLiveHomeFixturesSnapshot(data) {
			this.fixtures = data;
		},
		updateLiveHomeFixtures(data) {
			applyPatch(this.fixtures, data.patch);
		},
		setLiveHomeFixture(data) {
			this.fixtures[data.id] = data;
		},
		deleteLiveHomeFixture(data) {
			delete this.fixtures[data];
		},
		updateLiveHomeFixture(data) {
			this.fixtures[data.fixture_id] = data.data;
		},
		setLiveHomeFixturePatch(data) {
			if (!this.fixtures[data.fixture_id]) return;
			applyPatch(this.fixtures[data.fixture_id], data.patch)
		}
	},
})